var Request = function() {
  var self = this;

  self.get = function(options) {
    return $.ajax($.extend(true, {
      dataType: 'json',
      method: 'GET'
    }, options));
  };

  self.delete = function(options) {
    return $.ajax($.extend(true, {
      dataType: 'json',
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': window.payload.token
      }
    }, options));
  };

  self.post = function(options) {
    if (options.data) {
      options.data = JSON.stringify(options.data);
    }
    return $.ajax($.extend(true, {
      dataType: 'json',
      method: 'POST',
      headers: {
        'X-CSRF-Token': window.payload.token,
        'Content-Type': 'application/json'
      }
    }, options));
  };

  self.put = function(options) {
    if (options.data) {
      options.data = JSON.stringify(options.data);
    }
    return $.ajax($.extend(true, {
      dataType: 'json',
      method: 'PUT',
      headers: {
        'X-CSRF-Token': window.payload.token,
        'Content-Type': 'application/json'
      }
    }, options));
  };
};

window.request = new Request();